'use client';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import HowItWorksFooterCta from './_components/HowItWorksFooterCta';
import HowItWorksHero from './_components/HowItWorksHero';
import Timeline from './_components/Timeline';
import { timelineSections } from './_data/timelineSections';

const Content = (): JSX.Element => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();
  return (
    <div data-cy="how-it-works-page">
      <HowItWorksHero />
      <Timeline sections={timelineSections} />
      <HowItWorksFooterCta />
    </div>
  );
};

export default Content;
